import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Loader } from "@themes/pollinator/ui/Loader";
import { useSystemVariable } from "@platform/hooks/useSystemVariable";

export type Props = {
  children: ReactNode;
};

export function InvitationClosedGate({ children }: Props) {
  const { data, isLoading } = useSystemVariable("marketing_site_mode");

  if (isLoading) {
    return <Loader isFullPage />;
  }

  if (data?.value === "closed") {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export default InvitationClosedGate;
